import type { Agency } from "../types";
import { AgenciesPage } from "./AgenciesPage";

export const agencies = {
  list: AgenciesPage,
  recordRepresentation: (record: Agency) =>
    record?.name ?? record?.slug ?? "Agency",
};

export default agencies;
